import React, { useState } from "react";
import Nuova from "../imgs/Nuova orchestra.jpg";
import Concerto from "../imgs/concerto-messa.jpg";
import Orchestra from "../imgs/Nuova orchestra2.jpg";
import VideoChiesa from "../video/Video-chiesa.mp4";

const NuovaOrchestra = () => {
  return (
    <div className="flex flex-col items-center w-full ">
      <p className="text-red-600 font-extrabold xs:text-2x1 md:text-3xl">
        NUOVA ORCHESTRA DI MILANO
      </p>
      {/* <div className="flex xs:flex-col md:flex-row items-center sm:w-1/2 md:w-1/3"> */}
      <div className="flex xs:flex-col md:flex-row items-center justify-center sm:w-1/2 md:w-1/3">
        <img className="w-1/2" src={Nuova} />
        {/* <img className="w-1/2" src={Concerto} /> */}
      </div>
      <img className="xs:w-2/3 md:w-2/4" src={Orchestra} />
      <video
        src={VideoChiesa}
        muted
        autoPlay
        loop
        className="xs:w-2/3 md:w-2/4"
      ></video>

      <div className="flex flex-col items-center xs:text-sm sm:text-base text-center">
        <p>
          Direttore:{" "}
          <strong className="text-red-600">
            <a href="https://www.giuseppedinardo.it/">Giuseppe Dinardo</a>
          </strong>
        </p>
        <p>Violini primi</p>
        <p>Liliia Bodnar, Valeriia Bodnar, Rossella Serino, Cristina Chiesa</p>
        <p>
          <strong>Violini secondi</strong>
          <br />
          Simonetta Sargenti, Anna Maria Lombardi, Salvatormattia Caliò
        </p>
        <p>
          <strong>Viole</strong>
          <br />
          Mariangela Franco, Mario Montelli
        </p>
        <p>
          <strong>Violoncelli</strong>
          <br />
          Luca Russo Rossi, Vincenzo Mocata, Sonia Ilaria Maffioli, Mariella
          Mancuso
        </p>
        <p>
          <strong>Contrabbassi</strong>
          <br />
          Vito Tagliente, Sergio Fiacconi
        </p>
        <p>
          <strong>Flauti</strong>
          <br />
          Davide Gandino, Chiara Pasqualini, Samanta Rizzo, Andrea Cancellieri
        </p>
        <p>
          <strong>Oboe</strong>
          <br />
          Alessandro Nardi, Alessandro Saccomani
        </p>
        <p>
          <strong>Clarinetti</strong>
          <br />
          Mario Montani, Carlo Sandrini, Isabel Miret Ribes
        </p>
        <p>
          <strong>Fagotti</strong>
          <br />
          Vittorio Giola, Pietro Commessatti, Salvatore Longo
        </p>
        <p>
          <strong>Corni</strong>
          <br />
          Roberto Lonoce, Federico Ceccarelli, Antonio Bonatesta, Roberto Caliò
        </p>
        <p>
          <strong>Tromba</strong>
          <br />
          Antonio Dinardo
        </p>
        <p>
          <strong>Trombone</strong>
          <br />
          Luigi Bagnato
        </p>
      </div>

      <div className="mt-10 flex flex-col items-center text-center xs:w-10/12 ">
        <p>
          In un periodo storico in cui diverse orchestre hanno dovuto chiudere i
          battenti, MilARTE ha deciso di affrontare con determinazione questa
          sfida culturale. L’orchestra trae ispirazione dalle prestigiose
          formazioni internazionali e si configura come un autentico luogo di
          aggregazione, concepito per celebrare la bellezza intrinseca nel "Fare
          Musica". Al contempo, mira a promuovere la sensibilità verso i valori
          dell'arte e dello spirito di gruppo sociale.
        </p>
        <p>
          La <strong>Nuova Orchestra di Milano</strong> è dedicata
          principalmente al mondo semiprofessionale e professionale, composto da
          individui capaci di riconoscere la propria città e la propria
          dimensione musicale come unico e valido punto creativo. Il suo
          ambiente orchestrale offre uno spazio vitale per coltivare le passioni
          legate alla comunicazione sociale, artistica e culturale. Rappresenta
          un'opportunità senza pari per i musicisti che possiedono le competenze
          per suonare uno strumento e desiderano continuare a farlo all'interno
          di un contesto orchestrale.
        </p>
        <p>
          Questo progetto, di innegabile valore culturale ed educativo, allinea
          Milano a un modello di vita musicale improntato alla socializzazione,
          corresponsabilità e creatività, tanto da aprirsi a collaborazioni con
          altre città e realtà parallele sul territorio nazionale. La Nuova
          Orchestra di Milano si configura altresì come un veicolo culturale e
          promozionale, favorendo collaborazioni e interazioni socio-culturali
          con università, teatri, musei, Conservatori e scuole di Musica.
        </p>
      </div>
    </div>
  );
};

export default NuovaOrchestra;
